module.exports = "./img/ccf062e9f67e81fcbf47dc74e9ca9c96.jpg";